// DS: I78
// from GDrive
import React from 'react';
import IconWrap, { Props } from '../IconWrap';

const Plus: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 8">
      <path d="M4.75,3.25 L7,3.25 L7,4.75 L4.75,4.75 L4.75,7 L3.25,7 L3.25,4.75 L1,4.75 L1,3.25 L3.25,3.25 L3.25,1 L4.75,1 L4.75,3.25 Z" />
    </svg>
  </IconWrap>
);
Plus.displayName = 'Plus';

export default Plus;
